import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
// import ScrollToTopButton from '@/components/common/ScrollToTopButton';

export const MainLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      {/* <ScrollToTopButton /> */}
    </div>
  );
};
